import React from 'react';
import { DataDefinitionList, ButtonOBSOLETED } from '../../../../../web.common';
import EditEntity from '../../../../misc/EditEntity';
import { fields } from './fields';
import { formValidation } from './formValidation';
import withApi from '../../../../higherOrderComponents/withApi';
import { getFormData } from './getFormData';

export class EditProductFieldInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async delete() {
    const { id } = this.props;
    const { close, api: { products: { deleteProductField } } } = this.props;
    await deleteProductField(id);
    close(true);
  }

  render() {
    const { id } = this.props;
    const { close, api: { products: { getProductField, saveProductField } } } = this.props;
    const loadData = async () => getProductField(id);
    const editData = async (loadedData, formData) => {
      const updatedData = await saveProductField(loadedData, formData);
      this.setState({ shouldUpdate: true });
      return updatedData;
    };
    const entity = 'Product-Field';
    const editProps = {
      loadData,
      language: 'en',
      editData,
      titleContent: '',
      entity,
      getFormData,
      validation: formValidation()
    };

    return (
      <div>
        <h2>Edit Field</h2>
        <EditEntity {...editProps}>
          {(isEditMode, formData) => (
            <DataDefinitionList
              classNames={['border-0']}
              listData={fields(isEditMode, formData)}
              hasWideDescriptions
            />
          )}
        </EditEntity>

        <div
          classNames='edit-product-field-button'
          style={{ textAlign: 'center', display: 'table', margin: 'auto', marginTop: '20px' }}
        >
          <ButtonOBSOLETED
            type='button'
            color='danger'
            buttonContent={<div>Delete</div>}
            onClick={() => this.delete()}
          />
        </div>
        <br />
        <br />
        <ButtonOBSOLETED
          type='button'
          isFullWidth
          buttonColor='gray'
          buttonContent={<div>Close</div>}
          onClick={() => {
            const { shouldUpdate } = this.state;
            close(shouldUpdate);
          }}
        />

      </div>
    );
  }
}

export const EditProductField = withApi(EditProductFieldInternal);